/**
 * @file Renders the shared page layout: header, divider and body.
 */
import type { CSSProperties, ReactNode } from "react";
import { Divider } from "antd";
import type { MenuProps } from "antd";

import { W1 } from "@components/Constants";

import Header from "./Header";

type Props = {
  menu?: MenuProps["items"];
  title?: string;
  style?: CSSProperties;
  onSearch?: (value: string) => void;
  titleExtra?: ReactNode;
  children: ReactNode;
};

/**
 * Renders the page's header, a divider and its body content.
 */
const Page = ({
  menu = [],
  title = "",
  style = { padding: W1 },
  onSearch = undefined,
  titleExtra = undefined,
  children,
}: Props): JSX.Element => {
  return (
    <>
      <Header
        menu={menu}
        title={title}
        onSearch={onSearch}
        titleExtra={titleExtra}
      />

      <Divider style={{ margin: 0 }} />

      <div style={style}>
        {children}
      </div>
    </>
  );
};

export default Page;
